import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {debounceTime, filter, pairwise, startWith} from 'rxjs/operators';
import {SelectedFilter} from 'src/app/pages/menu/menu.page';
import {Api} from 'src/smoothr-web-app-core/api/api';
import ArticleCategory from 'src/smoothr-web-app-core/models/ArticleCategory';
import Localization from 'src/smoothr-web-app-core/models/Localization';
import Venue from 'src/smoothr-web-app-core/models/Venue';

interface ArrayItem {
	name: string;
	value: string;
	isOpen: boolean;
}
const ARRAY_OF_TAGS = [
	{
		name: 'Alles',
		value: 'alle'
	},
	{
		name: 'Veggie',
		value: 'vegetarian'
	},
	{
		name: 'Vegan',
		value: 'vegan'
	},

	{
		name: 'Neu',
		value: 'new'
	},
	{
		name: 'Ohne Gluten',
		value: 'glutenFree'
	},
	{
		name: 'Ohne Kohlenhydrate',
		value: 'noCarb'
	},
	{
		name: 'Ohne Laktose',
		value: 'lactoseFree'
	},

	{
		name: 'Basisch',
		value: 'basic'
	},
	{
		name: 'Proteinreich',
		value: 'notProtein'
	}
];

@Component({
	selector: 'app-filters-menu',
	templateUrl: './filters-menu.component.html',
	styleUrls: ['./filters-menu.component.scss']
})
export class FiltersMenuComponent {
	public acordionSwitch = [];
	public allCategories: ArticleCategory[] = [];
	public filterViewValue = SelectedFilter.CATEGORY;
	public dietArray: ArrayItem[];
	public dietTypeArray: ArrayItem[];
	public filterForm: FormGroup;
	public filterForm2: FormGroup;
	public selectedFilterMap = new Map();
	@Input() modalMode: boolean = false;
	@Input() set categories(value: ArticleCategory[]) {
		this.allCategories = [null, ...value];
	}
	@Input() set filterView(value: SelectedFilter) {
		this.filterViewValue = value;
	}
	@Input() selectedFilters: string[] = [];
	@Input() set venue(value: Venue) {
		const filtersTags = ARRAY_OF_TAGS;
		// value.tags.filter(
		// 	it =>
		// 		it.identifier !== 'next_day' &&
		// 		it.identifier !== 'empty' &&
		// 		it.identifier !== 'empty' &&
		// 		it.identifier !== 'hide_cart' &&
		// 		it.identifier !== 'cutlery'
		// );

		const veganArray = filtersTags
			.filter(v => v.value === 'alle' || v.value === 'vegan' || v.value === 'vegetarian')
			.filter((it, index) => filtersTags.findIndex(obj => obj.value === it.value) === index)
			.map(it => {
				return {
					name: it.name,
					value: it.value,
					isOpen: false
				};
			});
		const allArray = filtersTags
			.filter(v => v.value !== 'vegan' && v.value !== 'vegetarian' && v.value !== 'alle')
			.map(it => {
				return {
					name: it.name,
					value: it.value,
					isOpen: false
				};
			});
		this.dietArray = veganArray;
		this.dietTypeArray = allArray;

		this.createForm();
	}
	public filterEnum = SelectedFilter;
	@Input() selectedCategory: String | null = null;
	@Output() selectCategory = new EventEmitter<ArticleCategory | null>();
	@Output() filtersValue = new EventEmitter<{
		diet: {name: string; value: string}[];
		dietType: {name: string; value: string}[];
	}>();

	get dietArr(): FormArray {
		return this.filterForm.get('diet') as FormArray;
	}
	constructor(
		private fb: FormBuilder,
		private modalCtrl: ModalController
	) {}
	selectCategoryFun(value: ArticleCategory) {
		this.selectCategory.emit(value);
	}

	ngOnInit() {
		//
		this.createForm();
	}

	dismiss() {
		this.selectCategory.emit(null);
	}

	createForm() {
		this.filterForm = this.fb.group({
			diet: this.fb.array([])
		});
		this.filterForm2 = this.fb.group({
			dietType: this.fb.array([])
		});
		this.addDiet(this.dietArray);
		this.addDietType(this.dietTypeArray);
		this.filterForm.valueChanges.pipe(pairwise()).subscribe(([pre, v]) => {
			if (
				(v.diet[2].selected || v.diet[1].selected) &&
				!pre.diet[2]?.selected &&
				!pre.diet[1]?.selected &&
				pre?.diet[0]?.selected
			) {
				const patch = v.diet.map(it => {
					if (it.value === 'alle') {
						it.selected = false;
					}

					return it;
				});
				this.filterForm.controls.diet.patchValue(patch, {emitEvent: false});
			}

			if ((pre?.diet[2]?.selected || pre?.diet[1]?.selected) && !pre?.diet[0]?.selected && v.diet[0].selected) {
				let patch = v.diet.map(it => {
					it.selected = true;

					if (it.value === 'vegan' || it.value === 'vegetarian') {
						it.selected = false;
					}

					return it;
				});
				this.filterForm.controls.diet.patchValue(patch, {emitEvent: false});
			}
		});
	}
	addDiet(arr: {name: string; value: string; isOpen: boolean}[]) {
		const creds = this.filterForm.controls.diet as FormArray;
		const selectedItemsInFilters = new Map(this.selectedFilters.map(it => [it, it]));

		arr
			.map(it => {
				return {...it, selected: selectedItemsInFilters.has(it.value)};
			})
			.forEach(element => {
				if (element) {
					creds.push(
						this.fb.group({
							name: element.name,
							value: element.value,
							selected: element.selected,
							isOpen: element.isOpen
						})
					);
				}
			});
	}
	addDietType(arr: {name: string; value: string; isOpen: boolean}[]) {
		const creds = this.filterForm2.controls.dietType as FormArray;
		const selectedItemsInFilters = new Map(this.selectedFilters.map(it => [it, it]));

		arr
			.map(it => {
				return {...it, selected: selectedItemsInFilters.has(it.value)};
			})
			.forEach(element => {
				if (element) {
					creds.push(
						this.fb.group({
							name: element.name,
							value: element.value,
							selected: element.selected,
							isOpen: element.isOpen
						})
					);
				}
			});
	}
	emitFilters() {
		const res = {
			diet: this.filterForm?.value?.diet.filter(d => d.selected),
			dietType: this.filterForm2?.value?.dietType.filter(d => d.selected)
		};

		this.filtersValue.emit(res);
		this.modalCtrl.dismiss(res);
	}

	changeIsOpenDietType(index: number) {
		const formControlsArray = <FormArray>this.filterForm.controls['dietType'];
		formControlsArray.controls[index].patchValue({
			isOpen: formControlsArray.controls[index]?.value ? !formControlsArray.controls[index]?.value?.isOpen : false
		});
	}
	changeIsOpenDiet(index: number) {
		const formControlsArray = <FormArray>this.filterForm.controls['diet'];
		formControlsArray.controls[index].patchValue({
			isOpen: formControlsArray.controls[index]?.value ? !formControlsArray.controls[index]?.value?.isOpen : false
		});
	}

	firstCapital(str: string) {
		let res = '';
		for (let i = 0; i < str.length; i++) {
			if (i === 0) {
				res += str[0].toLocaleUpperCase();
			} else {
				res += str[i].toLocaleLowerCase();
			}
		}
		return res;
	}

	trackByArticleCategory(index: number, item: ArticleCategory) {
		return item?._id;
	}

	trackBy(index: number) {
		return index;
	}

	dismissModal() {
		this.modalCtrl.dismiss();
	}
}
function distinctUntilChanged(): import('rxjs').OperatorFunction<[any, any], unknown> {
	throw new Error('Function not implemented.');
}
